import { render, staticRenderFns } from "./SocialBoostIndex.vue?vue&type=template&id=03f3cf3c"
import script from "./SocialBoostIndex.vue?vue&type=script&lang=js"
export * from "./SocialBoostIndex.vue?vue&type=script&lang=js"
import style0 from "./SocialBoostIndex.vue?vue&type=style&index=0&id=03f3cf3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports